import { Reveal, Eyebrow } from "@/components/Reveal";

export const StorySection = () => (
  <section data-testid="story-section" className="bg-paper text-ink">
    <div className="mx-auto max-w-2xl px-5 py-24 text-center sm:py-32">
      <Reveal>
        <div className="mx-auto mb-10 w-40 overflow-hidden rounded-full border border-ink/10 shadow-[0_20px_50px_rgba(0,0,0,0.2)] sm:w-48">
          <img
            src="/assets/dasha-portrait.jpg"
            alt="Dasha Love"
            loading="lazy"
            className="aspect-[3/4] w-full object-cover object-top"
            data-testid="story-portrait"
          />
        </div>
        <Eyebrow dark>WHY I CARE SO MUCH ABOUT YOUR VISION</Eyebrow>
        <h2 className="mt-6 text-3xl font-extrabold leading-[1.08] tracking-tight sm:text-5xl">
          DON’T DIE WITH YOUR
          <br />
          <span className="font-serif italic font-medium text-wine">MAGIC</span> STILL INSIDE YOU.
        </h2>
      </Reveal>

      <Reveal className="mt-10 space-y-4 text-base text-ink/70 sm:text-lg" delay={0.1}>
        <p className="text-xl font-semibold text-ink sm:text-2xl">My mom died at 50, six months after her diagnosis.</p>
        <p>
          She had genius inside her. God-given wisdom. Dreams she never fully lived. So much of what was
          inside her never got the chance to become real.
        </p>
        <p>Losing her woke something up in me.</p>
        <p>Her death taught me that an unlived vision has a cost. Not just financially.</p>
      </Reveal>

      <Reveal className="my-10 space-y-2" delay={0.12}>
        {["The books unwritten.", "The places unseen.", "The love unexpressed.", "The ideas never created.", "The version of you your children never got to witness."].map((l) => (
          <p key={l} className="font-serif text-lg italic text-ink/60 sm:text-xl">{l}</p>
        ))}
      </Reveal>

      <Reveal delay={0.15}>
        <p className="text-3xl font-extrabold leading-[1.1] tracking-tight sm:text-5xl">
          I DON’T WANT
          <br />
          <span className="font-serif italic font-medium text-wine">“ONE DAY”</span>
          <br />
          FOR YOU.
        </p>
      </Reveal>

      <Reveal className="mt-10 space-y-4 text-base text-ink/70 sm:text-lg" delay={0.18}>
        <p>Life isn’t waiting for the perfect time. Your vision does not belong permanently inside your head.</p>
        <p className="font-semibold text-ink">
          Your ideas, wisdom, creativity, love and wildest dreams deserve the opportunity to exist in the world.
        </p>
      </Reveal>
    </div>
  </section>
);
